import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { selectCurrentUser } from '@store/selectors/current_user.selectors';

import { allRights } from '../all-rights';

export function getKeysFromBinary(
  rights: Record<string, { value: number } | Record<string, { value: number }>>,
  binaryValue: number,
): string[] {
  const keys: string[] = [];

  // Разворачиваем standard и special, если они существуют
  const flattenedRights: Record<string, { value: number }> = Object.entries(rights).reduce(
    (acc, [key, value]) => {
      if (typeof value === 'object' && !('value' in value)) {
        // Если это вложенный объект (например, standard или special)
        Object.assign(acc, value);
      } else {
        acc[key] = value as { value: number };
      }
      return acc;
    },
    {} as Record<string, { value: number }>,
  );

  // Основной цикл для проверки binaryValue
  for (const [key, right] of Object.entries(flattenedRights)) {
    if ((binaryValue & right.value) === right.value) {
      keys.push(key);
    }
  }

  return keys;
}

export const checkObjectAccess = (rawAccessList: string[], accessName: string): boolean => {
  if (!rawAccessList) {
    return false;
  }

  return rawAccessList.includes(accessName);
};

@Injectable({
  providedIn: 'root',
})
export class AccessService {
  private readonly httpClient = inject(HttpClient);
  private readonly store = inject(Store);

  private readonly allRights = allRights;

  get allAccessRights() {
    return this.allRights;
  }

  getAvailableAccessList() {
    return this.httpClient.get('access/available/');
  }

  checkUserCommonAccess(accessList: string[], entity = 'common'): boolean {
    let commonAccesses: any;
    this.store
      .select(selectCurrentUser)
      .pipe(take(1))
      .subscribe((user: any) => {
        if (typeof user?.commonAccesses === 'number') {
          commonAccesses = getKeysFromBinary(this.allRights[entity], user?.commonAccesses);
        } else {
          commonAccesses = user?.commonAccesses || [];
        }
      });
    return accessList.every((access) => checkObjectAccess(commonAccesses, access));
  }
}
